import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './assets/css/styles.css'
import { createHead } from '@unhead/vue/client'
import { Client } from 'appwrite';

const app = createApp(App);
const head = createHead()
const client = new Client()
    .setEndpoint('https://cloud.appwrite.io/v1')
    .setProject('65cef309524918fb9133');

app.provide('appwrite', client)
app.use(head)
app.use(router)
app.mount('#app')
